import { dataData } from 'dls-icons-data'
import { createIcon } from '../common'

const IconData = /*#__PURE__*/createIcon(dataData)
export default IconData
